<template>
    <v-card flat>
        <v-container>
            <v-card-text>
                <v-form :ref="currentFormRef" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-card-subtitle class="px-0">Announcement Preview</v-card-subtitle>
                            <v-alert :icon="getIcon" prominent text :color="getType">
                                {{ currentAnnouncement.announcement }}
                            </v-alert>
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Location
                        </v-col>
                        <v-col cols="12" md="9">
                            {{ currentAnnouncement['announcement-location'] }}
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Created By
                        </v-col>
                        <v-col cols="12" md="9">
                            {{ currentAnnouncement.createdByUsername }}
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Created Date
                        </v-col>
                        <v-col cols="12" md="9">
                            {{ currentAnnouncement.datecode }}
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Priority
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-select v-model="currentAnnouncement['announcement-class']" dense :disabled="!getAccess()"
                                :items="classItems" placeholder="Please select..." :rules="classRules" required>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Announcement
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-textarea v-model="currentAnnouncement['announcement']" auto-grow :disabled="!getAccess()"
                                outlined placeholder="Please provide announcement text..." required
                                :rules="announcementRules">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0 text-md-right">
                            Active
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-select v-model="currentAnnouncement['active']" dense :disabled="!getAccess()"
                                :items="activeItems" placeholder="Please select..." :rules="activeRules" required>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions v-if="getAccess()">
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" class="white--text" :color="successColor" :disabled="!valid"
                    @click="editAnnouncement">Save</v-btn>
                <v-btn :color="warningColor" @click="resetAnnouncement">Reset</v-btn>
            </v-card-actions>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name: 'announcements-edit',
    props: {
        item: {
            required: true
        },
        permission: {
            required: true, 
            type: Object
        }
    },
    data() {
        return {
            activeItems: [{
                text: 'Yes',
                value: '1'
            }, {
                text: 'No',
                value: '0'
            }],
            activeRules: [
                v => !(v === "") || 'Active is required',
            ],
            announcementRules: [
                v => !!v || 'Announcement text is required',
            ],
            classItems: [{
                color: '#f64e60',
                text: 'High',
                value: 'High'
            }, {
                color: '#ffb822',
                text: 'Moderate',
                value: 'Moderate'
            }, {
                color: '#1dc9b7',
                text: 'Low',
                value: 'Low'
            }, {
                color: '#5867dd',
                text: 'Informational',
                value: 'Informational'
            }],
            classRules: [
                v => !(v === "") || 'Priority is required',
            ],
            currentAnnouncement: {},
            currentFormRef: '',
            valid: true
        }
    },
    methods: {
        editAnnouncement() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            if (this.$refs[this.currentFormRef].validate()) {
                // Parse array into string
                formData.append('data', JSON.stringify(this.currentAnnouncement));
                formData.append('mode', 'updateEntity');
                formData.append('type', 'Announcements');

                // Loading icon
                this.$refs.confirmBtn.loading = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success result
                        if (json.result.match(/OK/i)) {
                            that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentAnnouncement['announcement-location']} has been successfully updated.`, true);
                        } else if (json.message.match(/UNAUTHORIZED/i)) {
                            that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                        } else {
                            that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentAnnouncement['announcement-location']} could not be updated. Please contact your system administrator.`, true);
                        }

                        that.$emit('refreshData');
                        that.$refs.confirmBtn.loading = false;
                    })
                    .catch(function () {
                        that.$emit('refreshData');
                        that.$refs.confirmBtn.loading = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        },
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        resetAnnouncement() {
            this.currentAnnouncement = {
                ...this.item
            };

            this.resetFormValidation();
        },
        resetFormValidation() {
            this.$refs[this.currentFormRef].resetValidation();
        },
        setAnnouncement() {
            this.currentAnnouncement = {
                ...this.item
            };

            this.currentFormRef = `${this.currentAnnouncement.id}Form`;
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        getIcon() {
            if (this.currentAnnouncement['announcement-class'] == "High") {
                return 'mdi-alert-octagon';
            } else if (this.currentAnnouncement['announcement-class'] == "Moderate") {
                return 'mdi-alert-circle';
            } else if (this.currentAnnouncement['announcement-class'] == "Low") {
                return 'mdi-check-circle';
            }

            return 'mdi-information';
        },
        getType() {
            if (this.currentAnnouncement['announcement-class'] == "High") {
                return '#f64e60';
            } else if (this.currentAnnouncement['announcement-class'] == "Moderate") {
                return '#ffb822';
            } else if (this.currentAnnouncement['announcement-class'] == "Low") {
                return '#1dc9b7';
            }

            return '#5867dd';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    },
    created() {
        this.setAnnouncement();
    },
    mounted() {
        this.resetFormValidation();
    }
}
</script>

<style scoped>
.v-text-field.v-input--dense {
    margin-top: 0;
}
</style>